<div>
    <app-sidebar></app-sidebar>
    <div class="main-content transition d-flex flex-column" [ngClass]="{ active: isSidebarToggled }"
        [class.right-sidebar]="themeService.isRightSidebar()" [class.hide-sidebar]="themeService.isHideSidebar()">
        <app-header></app-header>
        <app-hr-admin-dashboard></app-hr-admin-dashboard>
        <div class="flex-grow-1"></div>
        <app-footer></app-footer>
    </div>
</div>